import { selectMany } from "../../omnia"
import { ISoilService } from "../../types"
import { PlanField } from "../types"

export interface SelectableHsa {

    key: number

    hsa: Hsa

    selected: {
        value: boolean
        initial: boolean
    }

}

/**
 * Describes a single HSA (healthy soil assessment)
 */
export interface Hsa {

    hsaId: number

    samplingDate: Date

    /** Analysis number */
    number: string

    /** Field reference */
    reference: string

    /** Field id */
    fieldId: number

    infiltrationRate?: number

    vessScore?: number

    anecic?: number
    endogeic?: number
    epigeic?: number

}


export function getFieldHsa(fieldId: number, hsa: Hsa[], planField: PlanField): SelectableHsa[] {

    if (!fieldId) {
        return []
    }

    hsa = (hsa ?? []).filter(a => a.fieldId === fieldId)

    const excluded = new Set(planField.analyses.filter(a => (a.type === "hsa") && (!a.report)).map(a => a.id))

    return hsa.map(h => {

        const key = h.hsaId

        const selected = !excluded.has(key)

        return {

            key,

            hsa: h,

            selected: {
                value: selected,
                initial: selected
            }
        }

    })

}

export function getHsaFromSoilService(svc: ISoilService, targetYear: number): Hsa[] {

    return selectMany(

        svc.getHealthySoilsAssessments().map(h =>

            (h.Allocations ?? []).map(a => {

                const hsa: Hsa = {

                    hsaId: h.HealthySoilsAssessmentId,

                    fieldId: a.FieldId,

                    number: h.AnalysisNumber,
                    reference: h.FieldReference,
                    samplingDate: h.SamplingDate,

                    vessScore: h.VessScore,
                    infiltrationRate: h.InfiltrationRate,
                    anecic: h.Anecic,
                    endogeic: h.Endogeic,
                    epigeic: h.Epigeic

                }

                return hsa

            })

        )

    )

}
